export default __webpack_public_path__ + "media/images/favicon/android-chrome-48x48-22e3e7e9436dd70c77d1992324c3977b.png";